import View from './View.js';

class Main extends View {
  _area = document.querySelector('.campaign__detailInfo--btn');

  addHandlerClick(handler) {
    this._area.addEventListener('click', handler);
  }
}

export default new Main();
